import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
  getEquipmentTypeList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentType/list?pid='+param,
      method: 'post'
    })
  },
  getEquipmentInfoList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo/tree',
      method: 'post',
      data:param
    })
  },
  addEquipmentType(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentType',
      method: 'post',
      data:param
    })
  },
  addEquipmentInfo(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo',
      method: 'post',
      data:param
    })
  },
  editEquipmentType(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentType',
      method: 'put',
      data:param
    })
  },
  editEquipmentInfo(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo',
      method: 'put',
      data:param
    })
  },
  copyEquipmentType(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentType/copy',
      method: 'post',
      params:param
    })
  },
  copyEquipment(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo/copy',
      method: 'post',
      params:param
    })
  },
  delEquipmentType(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentType',
      method: 'DELETE',
      params:param
    })
  },
  delEquipmentInfo(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentInfo',
      method: 'DELETE',
      params:param
    })
  },
  getEquipmentInfoListUseState(param) {
	return request({
		url: store.getters.getPostUrl + 'mes/equipmentInfo/treeUseState',
		method: 'post',
		data: param
	})
  },
  homePage(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/equipmentInfo/homePage',
	  method: 'post',
	  params:{'day': param}
	})
  },
  getCustomerInfoList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/baseCustomer/customerInfo',
      method: 'post',
      data:param
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common/common.js